import React, { useState, useEffect } from 'react';
import { Notification, Column, Table, Modal, Box, Button, Delete, Progress, Select } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faEdit } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import QuestionService from '../../../services/question';
import QuestionsForm from '../Form';
import PaginationCustom from '../../components/PaginationCustom';

const config = { activeModal: false, page: null };

const styleHr = { backgroundColor: 'transparent', borderColor: 'rgb(221, 221, 221)', borderStyle: 'dashed', borderWidth: '1px 0px 0px', margin: '3px' };

const QuestionsList = () => {
  const [limit, setLimit] = useState(50);
  const [questions, setQuestions] = useState([]);
  const [pageOfItems, setPageOfItems] = useState([]);
  const [activeProgress, setActiveProgress] = useState(true);
  const [status, setStatus] = useState('');
  const [params, setParams] = useState(config);

  useEffect(() =>{
    fetchQuestions();
  },[limit])

  useEffect(() => {
    if (status!=='')
      setTimeout(() => setStatus(''), 5000);
  }, [status]);

  const fetchQuestions = async () => {
    try {
      const response = await QuestionService.index(limit);
      setQuestions(response.data.history);
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setActiveProgress(false);
    closeModal();
  }

  const renderQuestionsNewForm = () => {
    setParams({
      activeModal: true,
      page: <QuestionsForm fetchQuestions={fetchQuestions} newRecord={true} setMessage={setStatus} />
    })
  }

  const renderQuestionsEditForm = (index) => {
    setParams({
      activeModal: true,
      page: <QuestionsForm fetchQuestions={fetchQuestions} editRecord={true} setMessage={setStatus} question={pageOfItems[index]} />
    })
  }

  const deleteQuestion = async (index) => {
    if (window.confirm('Confirma a exclusão ?')) {
      const question = pageOfItems[index];
      try {
        console.log('Pergunta: ', question);
        await QuestionService.delete(question);
      } catch(e) {
        if (e.response)
          if (e.response.data.errors !== undefined)
            setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
          else
            setStatus(['danger', `${e.response.status}: ${e.response.data}`]);
        else
          setStatus(['danger', `${e.message}`]);
      }
      fetchQuestions();
    }
  }

  const renderModal = () => params.page;

  const closeModal = () => setParams(config);

  const onChangePage = (ppageOfItems) => {
    setPageOfItems(ppageOfItems);
  }

  const renderQuestions = () => {
    if (pageOfItems.length === 0)
      return (
        <Table.Row key={0}>
          <Table.Cell colSpan="9">
            { (activeProgress) ? <Progress size='small' color='custom-purple' /> : 'Não há perguntas frequentes.' }
          </Table.Cell>
        </Table.Row>
      )
    else
      return (
        pageOfItems.map((question, index) => (
          <Table.Row key={question._id}>
            <Table.Cell>{question.title}</Table.Cell>
            <Table.Cell>{question.answer}</Table.Cell>
            <Table.Cell>{moment(question.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
            <Table.Cell>
              <Button className="mb-1" size="small" color="" outlined onClick={() => renderQuestionsEditForm(index)} title="Editar">
                <FontAwesomeIcon icon={faEdit} />
              </Button><br/>
              <Button size="small" color="danger" outlined onClick={() => deleteQuestion(index)} title="Excluir">
                <FontAwesomeIcon icon={faTrashAlt} />
              </Button>
            </Table.Cell>
          </Table.Row>
        ))
      )
  }

  return (
    <>
      <Box>
        { 
          status!=='' && 
          <Notification color={status[0]}>
            <Delete as="button" onClick={() => setStatus('')} />
            {status[1]}
          </Notification>
        }
        <Column.Group>
          <Column style={{paddingBottom:'0.1rem'}} >
            Exibir até 
              <Select 
                name="limit"
                value={limit} 
                onChange={ e => setLimit(e.target.value) }
                style={{margin:'0 .5rem'}}
              >
                {
                  [{value: 50, description: '50'}, {value: 100, description: '100'}, {value: 200, description: '200'}, {value: 500, description: '500'}, {value: 1000, description: '1000'}].map(
                    (item, index) => (<Select.Option key={index} value={item.value}>{item.description}</Select.Option>)
                  )
                }
              </Select>
            perguntas
          </Column>
          <Column textAlign='right' style={{paddingBottom:'0.1rem'}}>
            <Button size="small" color="custom-purple" title="Nova Pergunta" onClick={renderQuestionsNewForm}>
              Nova Pergunta
            </Button>
          </Column>
        </Column.Group>
        <hr style={ styleHr }/>
        <Table fullwidth hoverable striped>
          <Table.Head>
            <Table.Row>
              <Table.Heading>Pergunta</Table.Heading>
              <Table.Heading>Resposta</Table.Heading>
              <Table.Heading>Criada em</Table.Heading>
              <Table.Heading>Ações</Table.Heading>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            { renderQuestions() }
          </Table.Body>
        </Table>
        <PaginationCustom items={questions} onChangePage={onChangePage} />
      </Box>

      <Modal closeOnBlur={true} closeOnEsc={true} active={params.activeModal} onClose={closeModal}>
        <Modal.Background onClick={closeModal} />
        <Modal.Content>
          { renderModal() }
        </Modal.Content>
        <Modal.Close />
      </Modal>
    </>
  )

}

export default QuestionsList;

